import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { XmlCursor } from './cursor/xmlCursor.class';

// @Injectable({
//   providedIn: 'root'
// })
export class XmlEditorDebugger implements OnDestroy {
  public actualCursorPosChanged$ = new Subject<XmlCursor>();
  public inputSelectionChanged$ = new Subject<string>();

  constructor() {}

  setActualCursorPos(pos: XmlCursor) {
    this.actualCursorPosChanged$.next(pos);
  }

  setInputSelection(info: string) {
    this.inputSelectionChanged$.next(info);
  }

  ngOnDestroy(): void {
    this.actualCursorPosChanged$.complete();
    this.inputSelectionChanged$.complete();
  }
}
